import { render } from "./template8.vue?vue&type=template&id=fe1d78da"
import script from "./template8.vue?vue&type=script&lang=js"
export * from "./template8.vue?vue&type=script&lang=js"

import "./template8.vue?vue&type=style&index=0&id=fe1d78da&lang=css"

import exportComponent from "C:\\Users\\john doe\\Documents\\Venice\\vnc\\AgendaBuilder\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__